module.exports = __webpack_public_path__ + "img/20200508_180620.2067ea51.jpg";